<div class="internet-explorer-warning">
    <img src="/assets/img/logo.svg" alt="SGC">
    <h2>Ooops, it seems you're using Internet Explorer...</h2>
    <p>Unfortunately, this browser is no longer supported. Try Edge, Chrome or Firefox to experience the new SGC website!</p>
    <p><a class="button" (click)="copyLink()">Copy website link</a> <span *ngIf="linkCopied">Link copied to clipboard. Paste it on your new browser!</span></p>
</div>